<template>
  <div>
    <el-dialog :visible.sync="dialogSetVisible" title="选择退货的产品序列号" @close="closeDialog" @open="openDialog">
      <div class="search-content">
        <div class="search-input">
          <span>产品型号:</span>
          <el-input v-model="productName" placeholder="查询产品型号" style="margin-bottom: 15px;margin-right:10px;width:30%" clearable />
          <span>序列号:</span>
          <el-input v-model="sn" placeholder="查询序列号" style="margin-bottom: 15px;width:30%" clearable />
        </div>
        <el-button type="primary" @click="onSearch()">
          查询
        </el-button>
        <!-- <div class="search-btn" /> -->
      </div>
      已发货产品序列号<el-button type="primary" style="margin-bottom: 15px" @click="addProduct">
        选择勾选的产品
      </el-button>
      <div v-loading="tableLoading" class="tableBody">
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChangeAppend">
          <el-table-column type="selection" width="55" />
          <!-- <el-table-column prop="shipProductCode" label="销售产品代码" align="left" /> -->
          <el-table-column prop="productModel" label="产品型号" align="left" />
          <el-table-column prop="materialCode" label="物料编号" align="left" />
          <el-table-column prop="snNumber" label="序列号" align="left" />
        </el-table>
        <!-- <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
          />
        </div> -->
      </div>
      <div class="search-content" style="padding:10px 0 ">
        <div class="search-input">
          <span>已选择{{ tableDataDel.length }}个序列号</span>
        </div>
      </div>
      已选产品序列号<el-button type="primary" style="margin-bottom: 15px" @click="removeProduct">
        删除勾选的产品
      </el-button>
      <el-table ref="multipleTable" :data="tableDataDel" border style="width: 100%" @selection-change="handleSelectionChangeDel">
        <el-table-column type="selection" width="55" />
        <!-- <el-table-column prop="shipProductCode" label="销售产品代码" align="left" /> -->
        <el-table-column prop="productModel" label="产品型号" align="left" />
        <el-table-column prop="materialCode" label="物料编号" align="left" />
        <el-table-column prop="snNumber" label="序列号" align="left" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetVisible = false">取 消</el-button>
        <el-button type="primary" :loading="tableLoading" @click="sureSet">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getDbContractDelivery } from '@/API';
export default {
  data () {
    return {
      dialogSetVisible: false,
      searchText: '',
      productName: '',
      sn: '',
      tableLoading: false,
      tableData: [], // 接口数据
      tableDataDel: [], // 本地存储数据
      multipleSelectionAppend: [],
      multipleSelectionDel: [],
      getData: {
        contractId: '',
        contractProductInfoList: []
      }
      // page: {
      //   pageSize: 10,
      //   total: 0,
      //   currentPage: 1
      // }
    };
  },
  methods: {
    closeDialog () {
      // 清空dialog内容
      this.tableDataDel = [];
      this.tableData = [];
      this.searchText = '';
      this.$emit('setSerialClose', false);
    },
    openDialog () {
      this.initData();
    },
    // handerSizeChange (val) {
    //   this.page.pageSize = val;
    //   this.initData();
    // },
    // handerCurrentChange (val) {
    //   this.page.currentPage = val;
    //   this.initData();
    // },
    sureSet () {
      // this.tableDataDel.forEach((item) => {
      //   if (item.materialCode !== this.rowData.rmaterialNum) {
      //     this.$notify.error({
      //       message: '请选择相同物料编码产品的产品序列号'
      //     });
      //   }
      // });
      for (var i = 0; i < this.tableDataDel.length; i++) {
        if (this.tableDataDel[i].materialCode !== this.rowData.rmaterialNum) {
          this.$notify.error({
            message: '请选择相同物料编码产品的产品序列号'
          });
          return;
        }
      }
      if (this.tableDataDel.length < 1) {
        return this.$notify.error({
          message: '请选择需要设置的产品'
        });
      }
      if (this.tableDataDel.length !== this.rowData.rproductNum) {
        return this.$notify.error({
          message: '请选择对应数量'
        });
      }

      this.$emit('setSerialClose', false);
      this.$emit('setProductSn', this.tableDataDel);
    },
    onSearch () {
      let parmas = {
        contractNum: this.$route.query.roldContractNum,
        productModel: this.productName,
        snNumber: this.sn
      };
      this.tableLoading = true;
      getDbContractDelivery(parmas).then((res) => {
        if (res.data.status === '200') {
          this.tableData = res.data.data;
          this.tableLoading = false;
        }
      }).catch((err) => {
        console.log(err);
        this.tableLoading = false;
      });
    },
    initData () {
      this.onSearch();
    },
    // 获取单行和index
    // copyRow (row, index) {
    //   console.log(row, index);
    //   this.tableDataDel.push(row);
    // },
    handleSelectionChangeAppend (val) {
      this.multipleSelectionAppend = val;
    },
    handleSelectionChangeDel (val) {
      this.multipleSelectionDel = val;
    },
    addProduct () {
      // 只赋值给下面表格,注意去重
      if (this.multipleSelectionAppend.length !== 0) {
        this.tableDataDel = this.tableDataDel.concat(this.multipleSelectionAppend);
        this.tableDataDel = this.deWeight(this.tableDataDel, 'snNumber');
      } else {
        this.$notify.error({
          message: '请选择需要添加的产品'
        });
      }
    },
    removeProduct () {
      if (this.multipleSelectionDel.length !== 0) {
        for (let i = 0; i < this.tableDataDel.length; i++) {
          for (let k = 0; k < this.multipleSelectionDel.length; k++) {
            if (this.tableDataDel[i].snNumber === this.multipleSelectionDel[k].snNumber) {
              this.tableDataDel.splice(i, 1);
            }
          }
        };
      } else {
        this.$notify.error({
          message: '请选择需要删除的产品'
        });
      }
    },
    // 数组中对象去重方法
    deWeight (arr, key) {
      var result = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i][key]]) {
          result.push(arr[i]);
          obj[arr[i][key]] = true;
        }
      }
      return result;
    }
  },
  props: {
    dialogvisible: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    rowData: {
      type: Object,
      default: () => {
        return 0;
      }
    },
    setSerialData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    dialogvisible (val) {
      this.dialogSetVisible = val;
    },
    setSerialData (val) {
      // console.log(val, 'this is val');
      this.getData.contractProductInfoList = val.getGoodsList;
      this.getData.contractId = val.contractId;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-content{
    display: flex;
    .search-btn{
      margin-left: 20px;
      width: 56px;
      margin-top: 30px;
      // flex-grow: 1;
    }
    .search-input{
      flex-grow: 1;
      width: 0;
      .el-input{
          margin-left: 10px;
          width: 70%;
      }
    }
  }
</style>
